import React from "react";
import { Box, Text } from "@chakra-ui/react";

/**
 * Renders the login page footer with copyright text.
 * @param {Object} props
 * @param {boolean} props.isMobile - Whether the viewport is mobile-sized
 * @returns {React.ReactElement}
 */
function LoginFooter({ isMobile }) {
    return (
        <Box
            p={isMobile ? "16px 20px" : "20px 24px"}
            bg="rgba(255, 255, 255, 0.02)"
            borderTop="1px solid rgba(255, 255, 255, 0.08)"
            textAlign="center"
        >
            <Text color="rgba(255, 255, 255, 0.5)" fontSize={isMobile ? "0.7rem" : "0.75rem"}>
                © 2024 KantoBiz Admin. Tous droits réservés.
            </Text>
        </Box>
    );
}

export default LoginFooter;
